import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';

import { GetContractUseCase, GetProfileUseCase, UserInterface } from '../../../core';
import { ErrorDialog } from '../../ui/dialog/error/error.dialog';
import { Loader } from '../../client/helpers/loader';

import { environment } from '../../../../environments/environment';

@Component({
    templateUrl: './contribution.page.html',
    styleUrls: ['./contribution.page.scss'],
})
export class ContributionPage implements OnInit {
    public user: UserInterface;
    public showBack = true;
    public back: Subject<boolean> = new Subject();
    public isClientPortal = environment.portalClient;

    constructor(
        private dialog: MatDialog,
        private getContractUseCase: GetContractUseCase,
        private getProfileUseCase: GetProfileUseCase,
        public loader: Loader
    ) {}

    ngOnInit() {
        if (!this.isClientPortal) {
            this.getProfile();
        }
    }

    private getProfile() {
        this.getProfileUseCase.bind().subscribe((transaction) => {
            if (transaction.isSuccess) {
                this.user = transaction.data;
            } else if (!transaction.isAuthError) {
                this.dialog.open(ErrorDialog, {
                    data: { text: transaction.error },
                });
            }
        });
    }

    showBackButton() {
        this.showBack = true;
    }

    hideBackButton() {
        this.showBack = false;
    }

    onBack() {
        this.back.next(true);
    }
}
